import EmployeePositionModel from "./EmployeePositionModel";
import LegalEntityBranchModel from "./LegalEntityBranchModel";
import LegalEntityModel from "./LegalEntityModel";
import UserModel from "./UserModel";

export default class EmployeeModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970,0,1);
			this.firstname = data.firstname;
			this.lastname = data.lastname;
			this.middlename = data.middlename;
			this.isMale = data.isMale;
			this.employer = data.employer;
			this.employerBranch = data.employerBranch;
			this.hireDate = data.hireDate;
			this.fireDate = data.fireDate;
			this.birthdate = data.birthdate;
			this.phone = data.phone;
			this.email = data.email;
			this.notes = data.notes;

			if (data.position && data.position.id) {
				this.position = new EmployeePositionModel(data.position);
			}

			if (data.positionGrade && data.positionGrade.id) {
				this.positionGrade = new EmployeePositionModel(data.positionGrade);
			}

			if (data.user && data.user.id) {
				this.user = new UserModel(data.user);
			}

			if (data.employer && data.employer.id) {
				this.employer = new LegalEntityModel(data.employer);
			}

			if (data.employerBranch && data.employerBranch.id) {
				this.employerBranch = new LegalEntityBranchModel(data.employerBranch);
			}
		}
	}

	id = 0;
	date = new Date(1970,0,1);
	firstname: string = "";
	lastname: string = "";
	middlename: string | null = null;
	isMale: boolean = false;   
	hireDate: Date = new Date(1970,0,1);
	fireDate: Date | null = null;
	birthdate: Date = new Date(1970,0,1);
	phone: string = "";
	email: string | null = null;
	notes: string | null = null;

	employer: LegalEntityModel | null = null;
	employerBranch: LegalEntityBranchModel | null = null;
	position: EmployeePositionModel | null = null;
	positionGrade: EmployeePositionModel | null = null;
	user: UserModel | null = null;
}
